import React from 'react';
import PageHeader from '../components/PageHeader';

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <PageHeader />
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl font-extrabold text-gray-900">Terms of Service</h1>
          <div className="mt-8 prose prose-indigo">
            <p className="text-lg text-gray-500">Last updated: March 1, 2024</p>

            <h2 className="text-xl font-bold mt-8 mb-4">1. Acceptance of Terms</h2>
            <p>
              By accessing and using 4D Seamless EMR's integration services, you accept and agree to be bound by these Terms of Service.
              If you do not agree to these terms, you should not use our services.
            </p>

            <h2 className="text-xl font-bold mt-8 mb-4">2. Description of Service</h2>
            <p>
              4D Seamless EMR provides an integration platform that enables healthcare providers to synchronize their EMR data with CRM systems.
              We reserve the right to modify, suspend, or discontinue any aspect of the service at any time.
            </p>

            <h2 className="text-xl font-bold mt-8 mb-4">3. User Accounts</h2>
            <p>You are responsible for:</p>
            <ul className="list-disc pl-5 mt-2">
              <li>Maintaining the confidentiality of your account</li>
              <li>Ensuring proper access controls within your organization</li>
              <li>Immediately reporting any security incidents</li>
              <li>Maintaining HIPAA compliance in your use of our services</li>
            </ul>

            <h2 className="text-xl font-bold mt-8 mb-4">4. Payment Terms</h2>
            <p>
              Subscription fees are billed in advance on a monthly or annual basis.
              Enterprise pricing and custom terms are available for healthcare organizations.
            </p>

            <h2 className="text-xl font-bold mt-8 mb-4">5. Data Privacy</h2>
            <p>
              Our services are HIPAA-compliant and all data processing adheres to healthcare privacy regulations.
              You must maintain appropriate BAA agreements and ensure HIPAA compliance in your use of our services.
            </p>

            <h2 className="text-xl font-bold mt-8 mb-4">6. Intellectual Property</h2>
            <p>
              All rights, title, and interest in and to the Service are and will remain the exclusive property of 4D Seamless EMR.
              Our trademarks may not be used in connection with any product or service without our prior written consent.
            </p>

            <h2 className="text-xl font-bold mt-8 mb-4">7. Limitation of Liability</h2>
            <p>
              4D Seamless EMR shall not be liable for any indirect, incidental, special, consequential, or punitive damages,
              or any loss of profits or revenues.
            </p>

            <h2 className="text-xl font-bold mt-8 mb-4">8. Changes to Terms</h2>
            <p>
              We reserve the right to modify these terms at any time.
              We will notify healthcare providers of any material changes via email or through the service.
            </p>

            <h2 className="text-xl font-bold mt-8 mb-4">9. Contact Information</h2>
            <p>
              For questions about these Terms, please contact us at:
              <br />
              <a href="mailto:legal@4d-seamless-emr.com" className="text-indigo-600 hover:text-indigo-500">
                legal@4d-seamless-emr.com
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}